module.exports = __webpack_public_path__ + "static/media/fujitsu.61c8ec60.png";